import { useMemo } from 'react'
import { useRecoilValue } from 'recoil'
import playerAtom, { IPlayerAtomState } from '@/pages/Dashboards/services/player/player.atom.ts'

const usePlayer = () => {
  const state = useRecoilValue(playerAtom)
  const { tsFrom, tsTo } = getCurrentPlayerTimestamps(state)

  return useMemo(
    () => ({
      tsFrom,
      tsTo,
      live: state.live,
      frame: getFrame(state),
    }),
    [state]
  )
}

const getFrame = (state: IPlayerAtomState) => {
  if (!state.live) {
    return state.offlineTsTo - state.offlineTsFrom + 1
  }

  switch (state.selectedTimeInternal) {
    case '1m':
      return 60 * 1000
    case '5m':
      return 5 * 60 * 1000
    case '30m':
      return 30 * 60 * 1000
    case '1h':
      return 60 * 60 * 1000
    case '12h':
      return 12 * 60 * 60 * 1000
    case '24h':
      return 24 * 60 * 60 * 1000
    case '7d':
      return 7 * 24 * 60 * 60 * 1000
    case '30d':
      return 30 * 24 * 60 * 60 * 1000
  }
}

const getCurrentPlayerTimestamps = (state: IPlayerAtomState) => {
  if (!state.live) {
    return {
      tsFrom: state.offlineTsFrom,
      tsTo: state.offlineTsTo,
    }
  }

  switch (state.selectedTimeInternal) {
    case '1m':
      return {
        tsFrom: new Date().getTime() - 60 * 1000,
        tsTo: new Date().getTime(),
      }
    case '5m':
      return {
        tsFrom: new Date().getTime() - 5 * 60 * 1000,
        tsTo: new Date().getTime(),
      }
    case '30m':
      return {
        tsFrom: new Date().getTime() - 30 * 60 * 1000,
        tsTo: new Date().getTime(),
      }
    case '1h':
      return {
        tsFrom: new Date().getTime() - 60 * 60 * 1000,
        tsTo: new Date().getTime(),
      }
    case '12h':
      return {
        tsFrom: new Date().getTime() - 12 * 60 * 60 * 1000,
        tsTo: new Date().getTime(),
      }
    case '24h':
      return {
        tsFrom: new Date().getTime() - 24 * 60 * 60 * 1000,
        tsTo: new Date().getTime(),
      }
    case '7d':
      return {
        tsFrom: new Date().getTime() - 7 * 24 * 60 * 60 * 1000,
        tsTo: new Date().getTime(),
      }
    case '30d':
      return {
        tsFrom: new Date().getTime() - 30 * 24 * 60 * 60 * 1000,
        tsTo: new Date().getTime(),
      }
  }
}

export default usePlayer
